import MainLayout from "./../../Layout/MainLayout";
import SoundsAccordian from "../../Components/SoundsAccordian";
import { useTranslation } from "react-i18next";
// css
import "./style.css";

const Sounds = () => {
  const { t } = useTranslation();

  return (
    <>
      <MainLayout title={t("nav.sounds")}>
        <SoundsAccordian list="sound page" />
      </MainLayout>
    </>
  );
};

export default Sounds;
